module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meWallet"
  }, [_c('div', {
    staticClass: "balance"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("账户余额（元）")]), _vm._v(" "), _c('h2', [_vm._v("\n        " + _vm._s(((_vm.postCustomerPreSave.present_balance || 0) + (_vm.postCustomerPreSave.non_present_balance || 0)).toFixed(2)))]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), (_vm.wxState) ? _c('div', {
    staticClass: "balanceBut"
  }, [_c('span', {
    staticClass: "But"
  }, [_c('router-link', {
    attrs: {
      "to": "/recharge"
    }
  }, [_vm._v("充值")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page1 page"
  }, [_c('ul', {
    staticClass: "pageItme"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": '/capitalRecord'
    }
  }, [_c('span', {
    staticClass: "Icon"
  }, [_c('i', {
    staticClass: "iconfont icon-zijinmingxi"
  })]), _vm._v("\n          资金流水\n          "), _c('i', {
    staticClass: "iconfont icon-jiantou"
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/coupon/nused'
    }
  }, [_c('span', {
    staticClass: "Icon"
  }, [_c('i', {
    staticClass: "iconfont icon-youhuiquanicon"
  })]), _vm._v("\n          优惠券\n          "), _c('i', {
    staticClass: "iconfont icon-jiantou"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.couponData.length) + "张")])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "iconfont icon-gth"
  }), _vm._v("支付费用时优先使用")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-646675d7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mewallet/mewallet.vue
// module id = 539
// module chunks = 0